import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ResolutionCreatedAuditItemDetails = ({ audit }) => {
  const { auditedChanges } = audit
  const { text } = auditedChanges

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> created the resolution:
      </span>
      <div className="mt-4 whitespace-pre-wrap">
        { text }
      </div>
    </div>
  )
}

ResolutionCreatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ResolutionCreatedAuditItemDetails
